import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubscriptionService } from './subscription.service';
import { Router } from '@angular/router';
import { Subscription as RxJsSubscription, Observable, NEVER } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UnauthorizedError } from '../util/http.service';
import { MatDialog } from '@angular/material/dialog';
import { Plan } from '../models/plan';
import { ActionConfirmer } from '../util/confirmation';
import { ActionConfirmationService } from '../util/confirmation/confirmation.service';
import { Subscription } from '../models/subscription';

@Component({
  selector: 'app-change-plan',
  templateUrl: './change-plan.component.html',
  styleUrls: ['./change-plan.component.scss'],
})
export class ChangePlanComponent implements OnInit, OnDestroy {
  sub$: Observable<Subscription>;

  pending = false;
  unauthorized = false;

  private subscription: RxJsSubscription = new RxJsSubscription();

  private actionConfirmer: ActionConfirmer;

  constructor(
    private subService: SubscriptionService,
    private router: Router,
    dialog: MatDialog
  ) {
    this.actionConfirmer = new ActionConfirmationService(dialog);
  }

  handlePlanSelect(plan: Plan) {
    this.subscription.add(
      this.actionConfirmer.confirmAction(
        `Are you sure you want to change subscription plan to ${plan.metadata.title}?`,
        () => {
          this.pending = true;
          this.subscription.add(
            this.subService.changePlan(plan.id).subscribe(() => {
              this.pending = false;
              this.router.navigate(['/billing']);
            })
          );
        }
      )
    );
  }

  ngOnInit() {
    this.sub$ = this.subService.getEntity().pipe(
      catchError((error: Error) => {
        if (error instanceof UnauthorizedError) {
          this.unauthorized = true;
        }
        return NEVER;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
